import React from 'react';
import { Container, Carousel, Row, Col, Image} from 'react-bootstrap';
import imt1 from "../../../images/testimonial/t1.jpg";
import imt2 from "../../../images/testimonial/t2.png";
import imt3 from "../../../images/testimonial/t3.jpeg";

import { useTranslation } from 'react-i18next';

const Testimonial = () => {
  const { t } = useTranslation();
  const testimonials = t('landing.testimonial.list', { returnObjects: true });

  return (
    <section id="testimonial" className="py-5">
      <Container style={{ paddingTop: '50px' }}>
        <h2 className="text-center mb-5"
          style={{
            backgroundColor: '#90EE90',
            color: '#fff',
            border: '1px solid #CECECE',
            paddingTop: '35px',
            paddingBottom: '25px',
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)'
          }}>
          {t('landing.testimonial.title')}
        </h2>

        <Carousel>
          {testimonials.map((testimonial, index) => (
            <Carousel.Item key={index}>
              <Row className="align-items-center">
                <Col xs={4}>
                  <Image
                    src={
                      index === 0 ? imt1 : index === 1 ? imt2 : imt3
                    }
                    alt={testimonial.name}
                    roundedCircle
                    fluid
                    className="carousel-imag"
                  />
                </Col>
                <Col xs={8}>
                  <h3>{testimonial.name}</h3>
                  <p>{testimonial.text}</p>
                </Col>
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

export default Testimonial;
